import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Avatar from '@material-ui/core/Avatar';
import profilePic from '../../public/faces/5.jpg';
import {Link} from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import customStyles from '../Styles/custom.module.css';
//import {AdminLogout} from '../Services/AdminLogin';
//import { AuthData } from '../Services/Authdata';
import { useHistory } from "react-router-dom";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export default function CustomizedMenus(props) {
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [message, setMessage] = React.useState("");
  const [state, setState] = React.useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });

  const { vertical, horizontal, open } = state;
//Snack

// const handleClickSnack = (newState,message) => {
//   setMessage(message);
//   setState({ open: true, ...newState });

// };

const handleCloseSnack = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }

  setState({ ...state, open: false });
};

//End

  let history = useHistory()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () =>{
    //console.log("Do You want to logout");
    //const data = {"id":AuthData().id};
//Make Admin Logout and redirect to logout
    // AdminLogout('admin/logout','POST',AuthData().token,data)
    // .then((result)=>{
    //   handleClickSnack({ vertical: 'top', horizontal: 'right' },result.message)
    //   sessionStorage.removeItem('userData');
    //   localStorage.removeItem("userData");
    //   setTimeout(function(){
    //     history.push('/login')
    //   },2000)
      
    // })
    sessionStorage.removeItem('userData');
      localStorage.removeItem("userData");
      setTimeout(function(){
        history.push('/login')
      },2000)
    handleClose()
  }
  const classes = withStyles({customStyles});
  return (
    <div>
      <Snackbar open={open} anchorOrigin={{ vertical, horizontal }} key={vertical + horizontal} autoHideDuration={6000} onClose={handleCloseSnack}>
        <Alert onClose={handleCloseSnack} severity="success">
         {message}
        </Alert>
      </Snackbar>
    <IconButton  aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="inherit"
        onClick={handleClick}>
            <Badge badgeContent={0} color="secondary">
              {/* <PersonIcon /> */}
              <Avatar alt="Remy Sharp" title={props.name} src={profilePic} className={classes.small} />
            </Badge>
    </IconButton>
      <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
     
    >
      <MenuItem onClick={handleClose}>
        {/* <Link to="/admin/profile">
        Profile
        </Link> */}
      </MenuItem>
      <MenuItem onClick={handleClose}>
        <Link to="/admin/profile">
        Profile
        </Link>
      </MenuItem>
      <Divider />
      <MenuItem onClick={logout} >
      Logout
      {/* <Link to="/logout" variant="body2">
        
      </Link> */}
      </MenuItem>
    </Menu>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/component/Popover.js